<template>

    <div class="rate-panel has-shadow bg-white mb-4">
        <div class="row">

            <div class="col-xl-6">
                <div class="rate-gallery">
                    <single-image-gallery v-bind:images="rateGroup.Images"></single-image-gallery>
                </div>
            </div>


            <div class="col-xl-11">
                <div class="p-5">
                    <h3 v-html="rateGroup.DisplayName"></h3>
                    <div v-html="rateGroup.Description"></div>


                </div>

            </div>

            <div class="col-xl-7">
                <div class="rate-selector">

                    <div class="rates p-3">
                        <div class="row">
                            <div class="col-24"
                                 v-for="rate in rateGroup.AvailableRates"
                                 v-bind:key="rate.PMSCode"
                                 v-bind:class="{'col-md-12 col-xl-24' : rateGroup.AvailableRates.length > 1 }">
                                <div class="rate  mb-3 p-3"
                                     v-on:click="onSelectRate(rate)"
                                     v-bind:class="{active : rate.availableRate != null && selectedRate && rate.availableRate.RateCode === selectedRate.availableRate.RateCode}">

                                    <div class="row">
                                        <div class="col-16 offset-3">
                                            <span class="rate-title-wrapper">

                                                <span class="rate-title" v-html="rate.rateGroupRate.DisplayName"></span>

                                                <span v-if="rate.rateGroupRate.Apply1stNightDepositRule" class="rate-condition"> - 1st night deposit required</span>

                                                <template v-else>
                                                    <span v-if="!rate.availableRate.RequiresDeposit" class="rate-condition">- Pay later</span>
                                                    <span v-if="wasPrice > rate.availableRate.Amount && discount(rate) != null " class="rate-condition">- {{discount(rate)}}</span>
                                                </template>
                                            </span>
                                            <p v-if="canShowCancellation(rate)">{{cancellationTime(rate)}}</p>


                                        </div>
                                    </div>
                                    <div class="price-wrapper" v-if="rate.availableRate">

                                        <span class="total">&pound;{{totalAmount(rate.availableRate.Amount || 0)}}</span>

                  

                                    </div>



                                </div>
                            </div>

                        </div>
                    </div>


                    <button class="btn btn--slate-blue btn--block btn-rate  btn--continue"
                            v-bind:disabled="isButtonDisabled"
                            v-on:click="onContinue()">
                        Next Step
                    </button>




                </div>
            </div>


        </div>


    </div>


</template>

<script>
    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';

    import { store } from '../store/index';


    export default {
        name: 'RatePanel',
        props: {
            leg: String,
            rateGroup: Object
        },
        components: {
            SingleImageGallery
        },
        //data() {
        //    return {
        //        rateSelected: null
        //    }
        //},

        computed: {

            session() {
                return store.getters.session
            },
            room() {
                return store.getters.booking.legs.find(item => item.leg == this.leg);
            },
            search() {
                return store.getters.search;
            },
            numberOfLegs() {
                return store.getters.numberOfLegs;
            },
            booking() {
                return store.getters.booking;
            },
            wasPrice() {
                const amounts = this.rateGroup.AvailableRates.map(x => x.availableRate.Amount);
                const max = Math.max(...amounts)
                return max;
            },

      
            selectedRate() {
                let currentLeg = store.getters.booking.legs.find(item => item.leg == this.leg);
     
                if (currentLeg.rate != undefined) {
                    return currentLeg.rate;
                }
                return null;
            },
            isButtonDisabled() {
                if (this.selectedRate != null) {
                
                    let item = this.rateGroup.AvailableRates.find(item => item.availableRate.RateCode === this.selectedRate.availableRate.RateCode);

                    return item == null;
                }
                return true;
            }
        },
        methods: {
            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },

            onSelectRate: function (rate) {

                let payload = {
                    leg: this.leg,
                    rate
                }

                store.dispatch("selectRate", payload);

            },
            onContinue: function () {

                this.trackRateSelection(this.leg);

                this.$emit('loading');

                store.dispatch("sendBooking", this.leg).then(t => {
                    let currentLeg = +this.leg;

                    if (currentLeg < this.numberOfLegs) {
                        this.$router.push({ name: 'stay_leg_room_availability', params: { id: this.session.Id, leg: currentLeg + 1 } });
                    }
                    else {

                        this.$router.push({ name: 'stay_guests', params: { id: this.session.Id } });
                    }
                }).catch(f => {
               
                    this.$emit('error');

                });
            },
            canShowCancellation(rate) {
            
                return moment(rate.availableRate.CancellationDateTime)>= moment();
            },
            cancellationTime(rate) {
                let result = '';

                let cancellationTime = moment(rate.availableRate.CancellationDateTime).format('ha');
                let cancellationDate = moment(rate.availableRate.CancellationDateTime).format('Do MMMM');

                if (rate.rateGroupRate.Apply1stNightDepositRule) {
                    return `Deposit refundable up to ${cancellationTime} on ${cancellationDate}`;
                }

                let requiresDeposit = rate.availableRate.RequiresDeposit;

                if (!requiresDeposit) {
                    result += 'Pay on arrival and cancel your stay up to ' + cancellationTime + ' on ' + cancellationDate;
                } else {
                    result += 'Non-refundable however changes can be made until ' + cancellationTime + ' on ' + cancellationDate ;
                }
                return result;
            },
            discount(rate) {
                
                let amount =  rate.rateGroupRate.DiscountAmount;
                if (amount > 0) {
                    return amount + '% off';
                }
                return null;

                //let amount = rate.Amount;
                //return (100 - Math.floor((this.totalAmount(amount) / this.totalAmount(this.wasPrice)) * 100)) + '% off';
                
            },
            totalAmount(amount) {

                let result = amount;
                //Forced inlcuded packages not to be included in rate...
                //if (this.room.includedPackages != null && this.room.includedPackages.length) {
                //    for (let i = 0; i < this.room.includedPackages.length; i++) {
                //        let p = this.room.includedPackages[i];
                //        result += p.Total;
                //    }
                //}
                return this.priceFormatted(result);

            },

            trackRateSelection(leg) {

                if (this.$gtm.enabled()) {

                    let legIndex = +(leg) - 1;
                    var roomRate = this.booking.legs[legIndex]?.room.PMSCode;
                    var roomName = this.booking.legs[legIndex]?.room.DisplayName;

                    let item = {
                        'item_id': roomRate + '-' + this.selectedRate.rateGroupRate.PMSCode,
                        'item_name': roomName + ' - ' + this.selectedRate.rateGroupRate.DisplayName,
                        'item_list_name': this.rateGroup.DisplayName,
                        'currency': this.selectedRate.availableRate.Currency,
                        'price': this.selectedRate.availableRate.Amount
                    };

                    window.dataLayer?.push({
                        'pageURL': '/stay/rate/' + this.leg,
                        'event': 'add_to_cart',
                        'ecommerce': {
                            'items' : [item]
                        }
                    });
                }
            }


        }
    }
</script>

